import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { PDFOptions } from './pdf-options';

@Component({
  selector: 'rl-pdf-viewer',
  templateUrl: './rl-pdf-viewer.component.html',
  styleUrls: ['./rl-pdf-viewer.component.scss']
})
export class rlPdfViewerComponent {
  @Input() url: string;
  @Input() config: PDFOptions;
  @Output() afterInit = new EventEmitter<any>();
  @Output() afterLoad = new EventEmitter<any>();
  @Output() searchResultsUpdated = new EventEmitter<number>();

  @ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;

  searchQuery: string;

  constructor() {}

  afterLoadPDF($event) {
    this.pdfComponent.pdfViewer.eventBus.on('updatefindmatchescount', (data) => {
      this.searchResultsUpdated.emit(data.matchesCount.total);
    });

    this.pdfComponent.pdfViewer.eventBus.on('updatefindcontrolstate', (data) => {
      if (data.matchesCount.total === 0) {
        //no match found
        this.searchResultsUpdated.emit(data.matchesCount.total);
      }
    });

    this.afterInit.emit({ pages: $event._pdfInfo.numPages });
  }

  search(str: string) {
    this.searchQuery = str;
    this.pdfComponent.eventBus.dispatch('find', {
      caseSensitive: false,
      findPrevious: undefined,
      highlightAll: true,
      phraseSearch: true,
      query: str
    });
  }

  nextResult = () =>
    this.pdfComponent.eventBus.dispatch('find', {
      caseSensitive: false,
      findPrevious: false,
      highlightAll: true,
      phraseSearch: true,
      query: this.searchQuery,
      type: 'again'
    });

  textLayerRendered(e: CustomEvent) {
    if (e['pageNumber'] === 1) {
      const firstPage = document.querySelector('.pdfViewer .page');
      firstPage.setAttribute('tabindex', '0');
    }
    this.afterLoad.emit(e);
  }
}
